import EventIcon from '@mui/icons-material/Event';

export default function CalendarDateLogo() {
  return (
      <EventIcon style={{ width: '100%', height: '100%', color: '#bb0000' }} />
  );
}
